<script setup lang="ts">
defineProps<{
  done?: 'never'
  next?: 'never'

  green?: boolean
  yellow?: boolean
  blue?: boolean
  black?: boolean
  completed: boolean
  size?: '24' | '28'
}>()
</script>

<template>
  <span :class="[$style.a, size === '24' ? '_svg24' : '_w28 _h28', { yellow, green, blue, black }]">
    <IconCheck v-if="completed" class="_svg20" />
    <IconArrow v-else chevron :class="$style.i" />
  </span>
</template>

<style module>
.a {
  composes: global(_a1);
  composes: global(_b0);
  composes: global(_ctr);
  composes: global(_bg5);
  composes: global(_c4);

  border-radius: 50%;
  z-index: 1;
}
.a:global(.yellow) {
  background: hsl(37deg 100% 92%);
  color: hsl(37deg 100% 31%);
}
.a:global(.green) {
  background: rgb(219, 245, 223);
  color: #50d166;
}
.a:global(.blue) {
  background: var(--blue3);
  color: var(--bg);
}
.a:global(.black) {
  color: var(--black-2);
  background: var(--bg);
}
:global(.d) .a:global(.black) {
  border: 1px solid var(--black-2);
}
.i {
  composes: global(_relative);
  left: -3px;
}
</style>
